import nlp from 'compromise';

// Greek verb endings for imperatives and common conjugations
const GREEK_VERB_PATTERNS = [
  // Imperative endings (singular)
  /ε$/,    // κάνε, γράψε, στείλε
  /α$/,    // διάβασα, έγραψα
  /σε$/,   // διάβασε, έγραψε
  // Present tense endings
  /ω$/,    // κάνω, γράφω
  /εις$/,  // κάνεις, γράφεις
  /ει$/,   // κάνει, γράφει
  /ουμε$/,  // κάνουμε
  /ετε$/,  // κάνετε
  /ουν$/,  // κάνουν
  // Past tense
  /ησα$/,  // έκανησα
  /ησες$/,
  /ησε$/,
  // Infinitive-like forms
  /σει$/,  // να κάνει, να γράψει
  /ψει$/,
  /ξει$/,
];

// Check if text contains Greek characters
function containsGreek(text: string): boolean {
  return /[\u0370-\u03FF\u1F00-\u1FFF]/.test(text);
}

// Check Greek text for verbs using pattern matching
function containsGreekVerb(text: string): boolean {
  const words = text.toLowerCase().split(/\s+/);
  
  for (const word of words) {
    // Skip very short words
    if (word.length < 2) continue;
    
    // Check against Greek verb patterns
    for (const pattern of GREEK_VERB_PATTERNS) {
      if (pattern.test(word)) {
        return true;
      }
    }
  }
  
  return false;
}

/**
 * Checks if the given text contains at least one verb
 * Uses grammar-based detection for English (compromise.js)
 * and pattern-based detection for Greek
 */
export function containsVerb(text: string): boolean {
  if (!text || text.trim().length === 0) {
    return false;
  }
  
  // Check for Greek text
  if (containsGreek(text)) {
    return containsGreekVerb(text);
  }
  
  // Use compromise for English
  const doc = nlp(text);
  const verbs = doc.verbs();
  
  return verbs.length > 0;
}
